// Pure functions only in helpers please!

export const getPositionForYaw = (position, currentYaw) => {
  const newYaw = currentYaw + position
  const pos = newYaw > 3.14 ? newYaw - 3.14 * 2 : newYaw

  return {
    x: Math.sin(-pos),
    z: Math.abs(pos)
  }
}

export const getScenesById = (sceneData, sceneIDs) => {
  if (!sceneIDs || !sceneData) return []

  return sceneIDs.map(id => sceneData.find(scene => scene.id === id))
}

export const buildHotspot = function(hotspot, viewer, scene) {
  // // Get the scene data.
  const { yaw, pitch, depth } = hotspot

  if (hotspot.id) {
    const el = document.getElementById(`hotspot-${hotspot.id}`)
    if (!el) return

    const perspective = { radius: depth || 500 }

    return scene.hotspotContainer().createHotspot(el, { yaw, pitch }, { perspective })
  }

  return null
}

export const setHotspotClasses = function(scene, hotspots) {
  // // Get the current viewport dimensions
  const size = scene.view().size()
  const regionSize = size.width / 1.5
  hotspots.forEach(function(hotspot) {
    if (!hotspot) return
    // Transform the hotspot coordinates into screen coordinates.
    const screen = scene.view().coordinatesToScreen({
      yaw: hotspot.position().yaw,
      pitch: hotspot.position().pitch
    })
    const elem = hotspot.domElement()
    // Check whether the hotspot is within regionSize pixels of the screen center.
    if(elem.id.includes("locked-portal")){
      if (!elem.classList.contains('is-in-view')) {
        elem.classList.add('is-in-view')
      }
    }
    else if (screen && Math.abs(screen.x - size.width / 2) < regionSize / 2) {
      if (!elem.classList.contains('is-in-view')) {
        elem.classList.add('is-in-view')
      }
    } else if (elem.classList.contains('is-in-view')) {
      elem.classList.remove('is-in-view')
    }
  })
}

export const buildScene = function(Marzipano, viewer, sceneData) {
  const state = this
  const geometry = new Marzipano.EquirectGeometry([{ width: 5000 }])
  const limiter = Marzipano.util.compose(
    //NOTE: You can place restrictions on a scene by defining the limits here.
    //SEE: https://www.marzipano.net/reference/RectilinearView.limit.html
    Marzipano.RectilinearView.limit.pitch(-0.7569001438792533, Math.PI / 2)
  )
  const view = new Marzipano.RectilinearView(sceneData.orientation, limiter)

  const source = Marzipano.ImageUrlSource.fromString(sceneData.source)
  const scene = viewer.createScene({
    id: sceneData.id,
    source,
    geometry,
    view,
    pinFirstLevel: true
  })

  // Disables zooming on scroll.
  viewer.controls().disableMethod('scrollZoom')

  return scene
}

export const positionalAudio = audio => {
  const aud = audio || []
  return aud.filter(a => typeof a.position === 'number')
}
